var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 16.625V4.375C18.375 3.4125 17.5875 2.625 16.625 2.625H4.375C3.4125 2.625 2.625 3.4125 2.625 4.375V16.625C2.625 17.5875 3.4125 18.375 4.375 18.375H16.625C17.5875 18.375 18.375 17.5875 18.375 16.625ZM7.4375 11.8125L9.625 14.4462L12.6875 10.5L16.625 15.75H4.375L7.4375 11.8125Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageicon);
export default __webpack_public_path__ + "static/media/imageicon.e031e508bc986afc700aa0e3960b044a.svg";
export { ForwardRef as ReactComponent };